import { render, staticRenderFns } from "./CustomTree.vue?vue&type=template&id=38109dd0&scoped=true"
import script from "./CustomTree.vue?vue&type=script&lang=js"
export * from "./CustomTree.vue?vue&type=script&lang=js"
import style0 from "./CustomTree.vue?vue&type=style&index=0&id=38109dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38109dd0",
  null
  
)

export default component.exports